module.exports = __webpack_public_path__ + "img/map-point-icon.ce8ecebd.svg";